import { useState } from "react";
import { BACKEND_URL } from "@/lib/api";

// Silent looping backdrop behind the homepage headline; fades in over the hero image once it can play.
export const HeroVideo = ({ placement }) => {
  const [ready, setReady] = useState(false);
  const { video } = placement;
  return (
    <video
      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${ready ? "opacity-100" : "opacity-0"}`}
      src={`${BACKEND_URL}${video.stream_url}`}
      poster={`${BACKEND_URL}${video.poster_url}`}
      autoPlay muted loop playsInline preload="auto"
      onCanPlay={() => setReady(true)}
      aria-hidden="true"
      data-testid="home-hero-video"
    />
  );
};
